import _ from 'lodash'
import { useSelector } from 'react-redux'

function useSelectedProject(selector) {
  return useSelector(state =>
    selector && _.isFunction(selector)
      ? selector(state.user?.selectedProject)
      : state.user?.selectedProject
  )
}

export default useSelectedProject
